import methods from '@/services/methods'

export default {
  create (payload) {
    return methods.sendMultipart(`imports`, payload)
  },
  list (payload) {
    return methods.sendGet(`imports`, payload, {noHyptoLoader: true, unprivilege: 'Bulk Imports'})
  },
  details (id) {
    return methods.sendGet(`imports/${id}`)
  },
  fetchCharges (payload) {
    return methods.sendGet(`imports/fetch_charges`, payload, {noHyptoLoader: true})
  },
  download (id, payload) {
    return methods.sendGet(`imports/${id}/download_url`, payload)
  },
  export (payload) {
    return methods.sendGet(`imports/export`, payload)
  },
  search (payload) {
    return methods.sendGet(`imports/search`, payload, {noHyptoLoader: true, unprivilege: 'Bulk Imports'})
  },
  transactions (payload) {
    return methods.sendGet(`imports/transactions`, payload, {noHyptoLoader: true, unprivilege: 'Import Details'})
  },
  transactionStatus (id, payload) {
    return methods.sendGet(`imports/transactions/${id}/status`, payload)
  },
  searchTransactions (payload) {
    return methods.sendGet(`imports/transactions/search`, payload, {noHyptoLoader: true, unprivilege: 'Import Details'})
  },
  exportTransactions (payload) {
    return methods.sendGet(`imports/transactions/export`, payload)
  },
  invalidTransactions (payload) {
    return methods.sendGet(`imports/invalid_entries`, payload, {noHyptoLoader: true, unprivilege: 'Import Details'})
  },
  searchInvalidTransactions (payload) {
    return methods.sendGet(`imports/invalid_entries/search`, payload, {noHyptoLoader: true, unprivilege: 'Import Details'})
  },
  exportInvalidTransactions (payload) {
    return methods.sendGet(`imports/invalid_entries/export`, payload)
  }
}
